import React, { useState, useEffect } from "react";

import {
    Box,
    Divider,
    TextField,
    Grid,
    Switch,
    FormControlLabel,
    styled,
    Card,
    Select,
    MenuItem,
    FormControl,
    FormHelperText,
    InputLabel,
    Checkbox,
    ListItemText,
    OutlinedInput,
    Chip,
    List,
    ListItem, InputAdornment
} from "@mui/material";

import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";

import CommonBreadcumbs from "../../common/CommonBreadcumbs";
import CommonSectionHeader from "../../common/CommonSectionHeader";
import CommonRestricted from "../../common/CommonRestricted";
import { useAppContextFeatures } from "../../../context/AppContext";

import {
    useWallets, targetTypes, currencyTypes
} from "../../../hooks/api/useWallets";
import { useSystemRoutes, routeTypes } from "../../../hooks/useSystemRoutes";

import { useTranslations } from "../../../hooks/useTranslations";

import {
    useLocations, locationTypes, targetTypes as locationTargetTypes
} from "../../../hooks/api/useLocations";
import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import {
    initialValues,
    validationSchema
} from "../../../schema/wallets/walletSchema";

import { useSystemHead, headTitles } from "../../../hooks/useSystemHead";
import {
    usePermissions, scopeIds, scopeTypes, functionTypes
} from "../../../hooks/usePermissions";
import { useStateCustomFields } from "../../../hooks/state/useStateCustomFields";
import { CommonIcons, icons } from "../../common/CommonIcons";

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

export default function NewWallet({
    routeType
}) {
    const { t } = useTranslations({ ns: ["common", "@wallet"] });

    const { promptMessage } = useSystemPrompt();
    const { setSystemLoading } = useAppContextFeatures();

    const { isLoading, create, filterOperatorTypes } = useWallets({ targetType: targetTypes.wallet });
    const { list: listLocation } = useLocations({ locationType: locationTypes.location, targetType: targetTypes.location });

    const { isPermissionAllow } = usePermissions(routeType, scopeIds.wallet.id,
        scopeTypes.wallet.wallet.id
    );

    const navigate = useNavigate();
    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType);

    const onSubmit = async (currentValues) => {

        try {

            const { rows } = values;

            let data = {
                wallet: {
                    name: currentValues?.walletName,
                    wallet_key: currentValues?.walletKey,
                    currency: currentValues?.currency,
                    primary_wallet: currentValues?.primaryWallet ? 1 : 0,
                    conversion_rate: currentValues?.conversionRate,
                    description: currentValues?.description,
                    status: currentValues?.status ? 1 : 0
                }
            };

            const response = await create({ data });

            promptMessage(true, `${response?.message}`);
            navigate(getRoute("settings/wallets"));

        } catch (error) {
            promptMessage(false, `Action Failed. (${error?.message})`);
        }

    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit
    });

    const { values, errors, touched, handleChange, setFieldValue } = formik;

    const RenderForm = () => {
        return (

            <form onSubmit={formik.handleSubmit}>
                <StyledCard>
                    <Grid container spacing={0.5}>

                        <Grid item xs={12} sm={12} md={3} textAlign={"left"}>

                            <CommonSectionHeader
                                title={t("walletInfo")}
                                subTitle={t("detailsOfWallet")}
                            />

                        </Grid>
                        <Grid item xs={12} sm={12} md={9}>
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={12} md={6}>
                                    <FormControlLabel
                                        sx={{
                                            marginLeft: "1px"
                                        }}
                                        control={
                                            <Switch
                                                sx={{
                                                    mt: 1
                                                }}
                                                name="status"
                                                checked={Boolean(
                                                    values.status)}
                                                onChange={(
                                                    event, checked) => {
                                                    setFieldValue(
                                                        "status",
                                                        checked
                                                    );

                                                }}
                                            />
                                        }
                                        label={
                                            Boolean(values.status) ?
                                                t("enabled") :
                                                t("disabled")
                                        }

                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <></>
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        margin="dense"
                                        size="small"
                                        autoFocus
                                        fullWidth
                                        name={"walletName"}
                                        label={t("walletName")}
                                        type="text"
                                        variant="outlined"
                                        value={values.walletName}
                                        onChange={handleChange}
                                        // onChange={(e) => {
                                        //     let val = e.target.value;
                                        //     console.log('e, val, val',
                                        // val) setFieldValue(`walletName`,
                                        // val)
                                        // setFieldValue(`description`,
                                        // val) }}
                                        error={Boolean(errors.walletName)}
                                        helperText={touched.walletName &&
                                            errors.walletName}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        margin="dense"
                                        size="small"
                                        autoFocus
                                        fullWidth
                                        name={"walletKey"}
                                        label={t("walletKey")}
                                        type="text"
                                        variant="outlined"
                                        value={values.walletKey}
                                        onChange={handleChange}
                                        // onChange={(e) => {
                                        //     let val = e.target.value;
                                        //     console.log('e, val, val',
                                        // val) setFieldValue(`walletName`,
                                        // val)
                                        // setFieldValue(`description`,
                                        // val) }}
                                        error={Boolean(errors.walletKey)}
                                        helperText={touched.walletKey &&
                                            errors.walletKey}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <FormControl
                                        margin="dense"
                                        fullWidth
                                        size="small"
                                        error={Boolean(errors.currency)}
                                    >
                                        <InputLabel id="currency">{t(
                                            "currency")}</InputLabel>
                                        <Select
                                            labelId="currency"
                                            label={t("currency")}
                                            name={"currency"}
                                            onChange={handleChange}
                                            value={values.currency}
                                            sx={{
                                                textAlign: "left"
                                            }}
                                        >
                                            {

                                                Object.keys(currencyTypes).
                                                    map((i, index) => {
                                                        return (
                                                            <MenuItem
                                                                key={index}
                                                                value={currencyTypes[i]}>
                                                                {currencyTypes[i]}
                                                            </MenuItem>
                                                        );
                                                    })
                                            }
                                        </Select>
                                        <FormHelperText>
                                            {errors?.currency}
                                        </FormHelperText>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        margin="dense"
                                        size="small"
                                        autoFocus
                                        fullWidth
                                        name={"conversionRate"}
                                        label={t("conversionRate")}
                                        type="text"
                                        variant="outlined"
                                        value={values.conversionRate}
                                        onChange={handleChange}
                                        error={touched.conversionRate &&
                                            Boolean(
                                                errors.conversionRate)}
                                        helperText={touched.conversionRate &&
                                            errors.conversionRate}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <FormControlLabel
                                        sx={{
                                            marginLeft: "1px"
                                        }}
                                        control={
                                            <Switch
                                                sx={{
                                                    mt: 1
                                                }}
                                                name="primaryWallet"
                                                checked={Boolean(
                                                    values.primaryWallet)}
                                                onChange={(
                                                    event, checked) => {
                                                    setFieldValue(
                                                        "primaryWallet",
                                                        checked
                                                    );
                                                }}
                                            />
                                        }
                                        label={
                                            Boolean(values.primaryWallet) ?
                                                t("isPrimaryWallet") :
                                                t("notPrimaryWallet")
                                        }

                                    />
                                </Grid>

                                <Grid item xs={12} sm={6} md={6}>
                                    <TextField
                                        margin="dense"
                                        size="small"
                                        fullWidth
                                        name={"description"}
                                        label={t("description")}
                                        type="text"
                                        multiline
                                        rows={2}
                                        variant="outlined"
                                        value={values.description}
                                        onChange={handleChange}
                                        error={touched.description &&
                                            Boolean(errors.description)}
                                        helperText={touched.description &&
                                            errors.description}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </StyledCard>
                <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
                    <Grid item md={12} textAlign={"right"}>
                        <LoadingButton
                            type="submit"
                            // fullWidth
                            variant="contained"
                            sx={{
                                mt: 3,
                                mb: 2
                            }}
                            loading={isLoading}
                        >
                            {t("saveChanges")}
                        </LoadingButton>
                    </Grid>
                </Grid>
            </form>

        );
    };

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.newWallet })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t("newWallet")}
                breadcrumbs={[
                    {
                        displayText: t("wallets"),
                        props: {
                            href: getRoute("settings/wallets")
                        }
                    },
                    {
                        displayText: t("newWallet"),
                        props: {
                            color: "secondary.main"
                        }
                    }
                ]}
            />


            {
                isPermissionAllow({ functionType: functionTypes.pageNew.id }) ?
                    RenderForm()
                    :
                    <CommonRestricted />
            }

        </Box>
    );
}